export default "__VITE_ASSET__BZta7EgC__"